<div class="modal fade modal--alert" id="mini-form-modal" tabindex="-1" role="dialog" aria-labelledby="modal-add-family-member" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="/assets/{{session_details?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <a href="#" class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">

          @for (item of questions; track item; let i = $index) {
            <app-question-controller
              [question]="item"
              [showLabel]="true"
              (questionAnswer)="onChange($event, i)"
              >
            </app-question-controller>
          }
        </div>

      </div>


      <div class="modal-alert__button">
        <div class="container">
          <a href="#" class="button button--lg button--secondary" data-toggle="modal" data-dismiss="modal">Cancel</a>
          <a href="#" class="button button--lg button--primary" [attr.disabled]="buttonDisabled" data-toggle="modal" (click)="addItem()" id="add-family-member-confirm" data-dismiss="modal">{{ edit ? 'Update': 'Add'}}</a>
        </div>
      </div>



    </div>
  </div>
</div>

<!-- <div class="button-box">
<a href="#modal-add-family-member" data-toggle="dialog" id="trigger-modal-add-family-member"
  class="button button--primary">Add a family
member</a>
</div>

<dialog class="dialog" id="modal-add-family-member">

  <div class="dialog-inner">
    <div class="dialog-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <a href="#" class="modal-alert__close" data-dismiss="dialog">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Add a family member</h3>
          </div>

          <div class="form-group form-group--sm">
            <label>Relationship to you</label>
            <select class="ui-selectmenu is-placeholder" id="ui-id-1" style="display: none;">
              <option value="">Please select</option>
              <option value="spouse">Spouse</option>
              <option value="child">Child</option>
              <option value="etc">Etc..</option>
              </select><span tabindex="0" id="ui-id-1-button" role="combobox" aria-expanded="false" aria-autocomplete="list" aria-owns="ui-id-1-menu" aria-haspopup="true" class="ui-selectmenu-button ui-selectmenu-button-closed ui-corner-all ui-button ui-widget"><span class="ui-selectmenu-icon ui-icon"></span><span class="ui-selectmenu-text">Please select</span></span>
            </div>

            <div class="form-group form-group--sm">
              <label>First name</label>
              <input type="text" value="" placeholder="First name" class="form-control">
            </div>

            <div class="form-group form-group--sm">
              <label>Last name</label>
              <input type="text" value="" placeholder="Last name" class="form-control">
            </div>


            <div class="form-group form-group--sm">
              <label>Date of birth</label>


              <div class="ui-datepicker__wrap">
                <div class="form-control__wrap has-icon">
                  <input type="text" class="form-control form-control--datepicker hasDatepicker" value="" placeholder="dd/mm/yyyy" id="add-family-member-dob"><button type="button" class="ui-datepicker-trigger"></button>
                  <span class="form-control__icon">
                    <svg class="icon">
                      <use xlink:href="#calendar"></use>
                    </svg>
                  </span>
                </div>
              </div>


            </div>

          </div>

        </div>


        <div class="modal-alert__button">
          <div class="container">
            <a href="#" class="button button--lg button--secondary" data-dismiss="dialog">Cancel</a>
            <a href="#" class="button button--lg button--primary" id="add-family-member-confirm" data-dismiss="dialog">Add</a>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-selectmenu-menu ui-front"><ul aria-hidden="true" aria-labelledby="ui-id-1-button" id="ui-id-1-menu" role="listbox" tabindex="0" class="ui-menu ui-corner-bottom ui-widget ui-widget-content"></ul></div></dialog> -->